import { useContext } from "react";
import { ToastContext } from "./toastContext";

// const toast = useToast(); toast.success("Saved"); toast.error("Failed");
export const useToast = () => {
  const toast = useContext(ToastContext);
  if (!toast) throw new Error("useToast must be used inside <ToastProvider>");
  return toast;
};
